import React from 'react'
import SecondaryButton from '../../Commons/Buttons/SecondaryButton'
import PrimaryButton from '../../Commons/Buttons/PrimaryButton'
import { Plus, Erase } from 'iconoir-react'
import { SharingOptionsFilters } from '../../../services/SharingOptions'
import { useRegulationPopUpQueries } from '../../../hooks/useRegulationPopUpQueries'
import GenericCombobox from '../../Commons/DropDownLists/GenericCombobox'

const excludeStatuses = [
    { value: 'charged', label: 'Facturé' },
    { value: 'canceled', label: 'Annulé' },
    { value: 'charged and canceled', label: 'Facturé et annulé' },
]

const RegulationPopUpFilter = ({
    setShowPopUpFilter,
    patient,
    setPatient,
    partner,
    setPartner,
    setType,
    type,
    object,
    setObject,
    handleErase,
    setStatus,
    status,
    user,
    setUser,
    setShareFilter,
    shareFilter,
    excludeStatus,
    setExcludeStatus,
}) => {
    const {
        patientsQuery,
        partnersQuery,
        usersQuery,
        typesQuery,
        objectsQuery,
        statusesQuery,
        debouncedSearchRef,
    } = useRegulationPopUpQueries()

    const handleValidation = () => {
        setShowPopUpFilter(false)
    }

    return (
        <div className="invisible-scrollbar fixed bottom-0 left-0 z-50 flex h-full w-full overflow-y-scroll bg-gray-600/50 text-gray-800 shadow-md">
            <div className="mx-auto w-full max-w-md pt-20 lg:max-w-lg xl:max-w-3xl">
                <div className="min-h-filter flex flex-col rounded-xl bg-white p-4">
                    {/* Header */}
                    <div className="flex justify-between border-b py-2">
                        <div className="flex items-center">
                            <h1 className="text-2xl font-bold">Filtrer</h1>
                            <i className="fa fa-filter pl-2 text-base" />
                        </div>

                        <SecondaryButton
                            label="Réinitialiser"
                            icon={<Erase />}
                            action={handleErase}
                            className={
                                !patient &&
                                !partner &&
                                !object &&
                                !status &&
                                !user &&
                                'hidden'
                            }
                        />
                    </div>

                    {/* Filter Form */}
                    <div className="my-auto grid gap-2 pb-5 lg:grid-cols-2 lg:gap-5">
                        {/* Patient Select */}
                        <GenericCombobox
                            icon="fa-user-injured"
                            label="Patient"
                            options={patientsQuery.data}
                            value={patient}
                            showAllOptions={false}
                            onChange={setPatient}
                            onInputChange={debouncedSearchRef}
                            isLoading={patientsQuery.isFetching}
                            isClearable={!!patient}
                            placeholder="Rechercher un patient..."
                        />

                        {/* Partner Select */}
                        <GenericCombobox
                            icon="fa-hands-helping"
                            label="Partenaire"
                            options={partnersQuery.data || []}
                            value={partner}
                            onChange={setPartner}
                            isLoading={partnersQuery.isLoading}
                            isClearable={!!partner}
                            placeholder="Sélectionner un partenaire..."
                        />

                        {/* Share Filter */}
                        <GenericCombobox
                            icon="fa-hand-holding"
                            label="Partage"
                            options={SharingOptionsFilters}
                            value={shareFilter}
                            showAllOptions={true}
                            onChange={setShareFilter}
                            isClearable={!!shareFilter}
                            placeholder="Sélectionner une option de partage..."
                        />

                        {/* User Select */}
                        <GenericCombobox
                            icon="fa-user"
                            label="Utilisateur"
                            options={usersQuery.data || []}
                            value={user}
                            showAllOptions={true}
                            onChange={setUser}
                            isLoading={usersQuery.isLoading}
                            isClearable={!!user}
                            placeholder="Sélectionner un utilisateur..."
                        />

                        {/* Status Select */}
                        <GenericCombobox
                            icon="fa-info-circle"
                            label="Statut"
                            options={statusesQuery.data || []}
                            value={status}
                            showAllOptions={true}
                            onChange={setStatus}
                            isLoading={statusesQuery.isLoading}
                            isClearable={!!status}
                            placeholder="Sélectionner un statut..."
                        />

                        {/* Type Select */}
                        <GenericCombobox
                            icon="fa-ambulance"
                            label="Type"
                            options={typesQuery.data || []}
                            value={type}
                            showAllOptions={true}
                            onChange={setType}
                            isLoading={typesQuery.isLoading}
                            isClearable={!!type}
                            placeholder="Sélectionner un type..."
                        />

                        {/* Object Select */}
                        <GenericCombobox
                            icon="fa-bullseye"
                            label="Objet"
                            options={objectsQuery.data || []}
                            value={object}
                            onChange={setObject}
                            showAllOptions={true}
                            isLoading={objectsQuery.isLoading}
                            isClearable={!!object}
                            placeholder="Sélectionner un objet..."
                        />

                        {/* Exclude Status Select */}
                        <GenericCombobox
                            icon="fa-times"
                            label="Exclure statut"
                            options={excludeStatuses}
                            value={excludeStatus}
                            showAllOptions={true}
                            onChange={setExcludeStatus}
                            isClearable={!!excludeStatus}
                            placeholder="Sélectionner un statut à exclure..."
                        />
                    </div>

                    {/* Footer Actions */}
                    <div className="mt-auto flex justify-between border-t pt-5">
                        <SecondaryButton
                            label="Annuler"
                            action={() => setShowPopUpFilter(false)}
                        />
                        <PrimaryButton
                            label="Valider"
                            action={handleValidation}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RegulationPopUpFilter
